/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/filter.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { ApiFilter, GoogleRpcStatus } from '../models/index';
import {
  ApiFilterFromJSON,
  ApiFilterToJSON,
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusToJSON,
} from '../models/index';

/**
 *
 */
export class DummyFilterServiceApi extends runtime.BaseAPI {
  /**
   */
  async getFilterRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiFilter>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/apis/v1beta1/filters`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiFilterFromJSON(jsonValue));
  }

  /**
   */
  async getFilter(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiFilter> {
    const response = await this.getFilterRaw(initOverrides);
    return await response.value();
  }
}
